import { render, staticRenderFns } from "./CreateBplSeasonal.vue?vue&type=template&id=1375a3d7&scoped=true"
import script from "./CreateBplSeasonal.vue?vue&type=script&lang=js"
export * from "./CreateBplSeasonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1375a3d7",
  null
  
)

export default component.exports